import React, { useState, useEffect } from "react";
import Modal from "./Modal";
import { PublicUrl } from "../config/config";

export default function SwitchClinicTip() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const showTip = localStorage.getItem("show-tip");
    if (showTip !== "false") {
      setIsModalOpen(true);
    }
  }, []);

  const closeModal = (dontShowAgain) => {
    setIsModalOpen(false);
    document.body.classList.remove("dfchat-modal-open");
    if (dontShowAgain) {
      localStorage.setItem("show-tip", "false");
    }
  };

  return (
    <Modal isOpen={isModalOpen} onClose={() => closeModal(false)}>
      <div
        style={{
          textAlign: "left",
          fontSize: 14,
          padding: 20,
        }}
      >
        Clicking the switch icon will allow you to switch between the clinics
        for this dental practice
      </div>
      <img
        src={`${PublicUrl}switch-clinic-tip.png`}
        style={{ width: "100%" }}
        alt="tip"
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          columnGap: "0.1rem",
          height: 50,
          marginTop: 20,
          marginLeft: 40,
        }}
      >
        <button
          className="multi-clinic-button"
          style={{ width: "100px", fontSize: 12 }}
          onClick={() => {
            closeModal(false);
          }}
        >
          Okay
        </button>
        <button
          className="multi-clinic-button"
          style={{ fontSize: 12 }}
          onClick={() => {
            closeModal(true);
          }}
        >
          Got it. Don't show this again.
        </button>
      </div>
    </Modal>
  );
}
